/**
 * A doctor's own saved treatment plans (/doctor-templates). The backend owns
 * ownership: every call acts on the signed-in doctor's templates only.
 */
import { ROUTES } from "../constants";
import type { ConditionKey } from "../constants/dental.constants";
import type { TemplateItem } from "../utils/dental-plan";
import { apiRequest } from "./api.client";

export interface DoctorTemplate {
  template_id: string;
  kind: "dental_plan";
  condition_key: ConditionKey | null;
  name: string;
  payload: { items: TemplateItem[] };
  is_favourite: boolean;
  created_at: string;
  updated_at: string;
}

export interface DoctorTemplateCreate {
  kind: "dental_plan";
  condition_key: ConditionKey;
  name: string;
  payload: { items: TemplateItem[] };
  is_favourite: boolean;
}

export interface DoctorTemplateUpdate {
  name?: string;
  payload?: { items: TemplateItem[] };
  is_favourite?: boolean;
}

export const DoctorTemplateAPI = {
  list(): Promise<DoctorTemplate[]> {
    return apiRequest<DoctorTemplate[]>(ROUTES.DOCTOR_TEMPLATES("dental_plan"));
  },
  create(body: DoctorTemplateCreate): Promise<DoctorTemplate> {
    return apiRequest<DoctorTemplate>(ROUTES.DOCTOR_TEMPLATE_CREATE, { method: "POST", body: JSON.stringify(body) });
  },
  update(id: string, body: DoctorTemplateUpdate): Promise<DoctorTemplate> {
    return apiRequest<DoctorTemplate>(ROUTES.DOCTOR_TEMPLATE(id), { method: "PATCH", body: JSON.stringify(body) });
  },
  remove(id: string): Promise<void> {
    return apiRequest<void>(ROUTES.DOCTOR_TEMPLATE(id), { method: "DELETE" });
  },
};
